// @ts-nocheck
import Vue from "vue";
export default Vue.extend({
    props: {
        value: {
            required: true,
        },
        formatter: {
            required: true,
        },
        "hide-zero": {
            type: Boolean,
            default: false,
        },
        monospace: {
            type: Boolean,
            default: false,
        },
        selectOnFocus: {
            type: Boolean,
            default: true,
        },
        align: {
            type: String,
            default: "left",
            validator(value) {
                return ["left", "center", "right"].includes(value);
            },
        },
    },
    data() {
        return {
            normalizedData: undefined,
            formattedData: undefined,
            focused: false,
        };
    },
    watch: {
        value(updatedValue) {
            this.normalizedData = updatedValue;
            if (!this.focused) {
                this.formatData();
            }
        },
    },
    mounted() {
        let initialValue = this.value;
        // Vuetify will ignore validation for the number 0. To handle edge case,
        // convert to the string '0'
        if (typeof this.value == "number") {
            initialValue = this.value.toString();
        }
        this.normalizedData = initialValue;
        this.formattedData = initialValue;
        this.highjackValidation();
        this.formatData();
    },
    methods: {
        normalizeData() {
            this.formattedData = this.normalizedData;
        },
        formatData() {
            const isValid = this.$refs.field.validate();
            // If the input is invalid, we normalize input.
            // Will prevent NaN errors and such.
            if (!isValid) {
                this.normalizeData();
                return;
            }
            if (this.hideZero && this.normalizedData == 0) {
                this.formattedData = "";
                return;
            }
            this.formattedData = this.formatter(this.normalizedData);
        },
        // The validation method is highjacked to always use the normalized value,
        // otherwise formatted value is used for validation if field is not focused.
        //
        // There is an edge case when:
        //     this.normalizedData == <a falsy falue>
        //     and
        //     this.formattedData != undefined
        //
        // This is due to Vuetify's validate function checking input parameters for
        // truthy-ness.
        //
        // Make sure formattedData == undefined when normalizedData == <falsy>
        highjackValidation() {
            this.$refs.field.validateOrig = this.$refs.field.validate;
            this.$refs.field.validate = (force = false) => {
                return this.$refs.field.validateOrig(force, this.normalizedData);
            };
        },
        validate() {
            return this.$refs.field.validate();
        },
        async onFocus(event) {
            this.focused = true;
            this.normalizeData();
            if (this.selectOnFocus) {
                await this.$nextTick();
                event.target.select();
            }
        },
        onBlur() {
            this.focused = false;
            this.formatData();
        },
        onChange(updatedValue) {
            this.normalizedData = updatedValue;
            this.$emit("input", this.value);
        },
    },
});
